"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByCreatedDate = void 0;
exports.sortByCreatedDate = function (a, b) {
    if (!a.createdDate || isNaN(Date.parse(a.createdDate.toString())))
        return 1;
    if (!b.createdDate || isNaN(Date.parse(b.createdDate.toString())))
        return 1;
    var aDate = new Date(a.createdDate);
    var bDate = new Date(b.createdDate);
    return aDate > bDate ? -1 : 1;
};
